import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';

import { MatIconModule } from '@angular/material/icon';

import { AuthService } from '../../../core/services/auth.service';
import { ThemeService } from '../../../core/services/theme.service';
import { LoginService } from '../../../features/login/services/login.service';
import { AppSettingsService } from '../../../core/services/app-settings.service';

@Component({
  selector: 'app-mobile-topbar',
  standalone: true,
  imports: [CommonModule, MatIconModule],
  templateUrl: './mobile-topbar.component.html',
  styleUrl: './mobile-topbar.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MobileTopbarComponent {
  private readonly router = inject(Router);
  private readonly authService = inject(AuthService);
  private readonly loginService = inject(LoginService);
  protected readonly appSettingsService = inject(AppSettingsService);
  protected readonly themeService = inject(ThemeService);

  @Output() menuClick = new EventEmitter<void>();

  @Input() isMenuOpen = false;

  protected toggleMenu(): void {
    this.menuClick.emit();
  }

  protected logout(): void {
    const refreshToken = this.authService.getRefreshToken();

    if (!refreshToken) {
      this.authService.clearSession();
      this.router.navigate(['/login']);
      return;
    }

    this.loginService.logout(refreshToken).subscribe({
      next: () => {
        this.authService.clearSession();
        this.router.navigate(['/login']);
      },
      error: () => {
        this.authService.clearSession();
        this.router.navigate(['/login']);
      },
    });
  }
}